import * as React from 'react';

export default () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect
      width="70"
      height="70"
      rx="35"
      fill="#47c758"
      id="rect2"
      x="0"
      y="0"
    />
    <path
      d="m 48.9539,21.969 c -3.5804,-3.5889 -8.3484,-5.5628 -13.4156,-5.5628 -10.459,0 -18.9697,8.5108 -18.9697,18.9698 0,3.341 0.8716,6.6052 2.5293,9.4848 l -2.6917,9.8267 10.0574,-2.6404 c 2.7686,1.5125 5.8875,2.3071 9.0662,2.3071 h 0.0085 c 10.4505,0 19.1492,-8.5107 19.1492,-18.9697 0,-5.0671 -2.1533,-9.8266 -5.7336,-13.4155 z M 35.5383,51.1584 c -2.8369,0 -5.614,-0.7605 -8.0322,-2.196 l -0.5725,-0.3418 -5.9644,1.5637 1.5894,-5.8191 -0.376,-0.5981 c -1.5808,-2.5122 -2.4097,-5.4089 -2.4097,-8.3911 0,-8.6902 7.0752,-15.7654 15.774,-15.7654 4.2126,0 8.1689,1.6406 11.1426,4.6228 2.9736,2.9822 4.8022,6.9385 4.7937,11.1511 0,8.6988 -7.2547,15.7739 -15.9449,15.7739 z m 8.6475,-11.809 c -0.47,-0.2393 -2.8027,-1.3843 -3.2385,-1.5381 -0.4358,-0.1624 -0.752,-0.2393 -1.0681,0.2392 -0.3162,0.4786 -1.222,1.5381 -1.504,1.8628 -0.2734,0.3162 -0.5554,0.3589 -1.0253,0.1197 -2.7857,-1.3929 -4.6143,-2.4866 -6.4515,-5.6397 -0.487,-0.8374 0.4871,-0.7776 1.3929,-2.5891 0.1538,-0.3162 0.0769,-0.5896 -0.0428,-0.8289 -0.1196,-0.2392 -1.0681,-2.572 -1.4611,-3.5205 -0.3846,-0.9228 -0.7776,-0.7946 -1.0682,-0.8117 -0.2734,-0.0171 -0.5896,-0.0171 -0.9057,-0.0171 -0.3162,0 -0.8289,0.1196 -1.2647,0.5896 -0.4358,0.4785 -1.6577,1.6235 -1.6577,3.9563 0,2.3327 1.7005,4.5886 1.9312,4.9048 0.2392,0.3161 3.341,5.1013 8.1006,7.1606 3.0078,1.2988 4.187,1.4099 5.6909,1.1877 0.9143,-0.1367 2.8027,-1.145 3.1958,-2.2558 0.393,-1.1109 0.393,-2.0593 0.2734,-2.2559 -0.1111,-0.2136 -0.4272,-0.3332 -0.8972,-0.5639 z"
      fill="#ffffff"
      id="path4"
    />
  </svg>
);
